import React, { useState } from 'react'
import {
	CurrentItemPreview,
	Body,
	Name,
	Preview,
	Price,
	DeleteIcon,
} from './style'
import { Icon } from 'components/Icon'
import ItemAttributes from '../ItemAttributes'
import { formatPrice } from '../../utils/common'
import { NoPreview } from '../../containers/Orders/components/ReturnItem/style'
import { setIsNeedToRemoveExchangeVariant } from '../../containers/Exchange/slice'
import { useDispatch } from 'react-redux'
import { overflowBodyRemove } from 'utils/common'

/* TODO: Ask Nikolay how to make modification */
let controlType = 'returnado-remove-item'

const ItemPreview = ({
	isActive,
	imageUrl,
	name,
	attributes,
	price,
	orderId,
	flow,
	orderItemId,
	isHandled,
	setFlow,
	onClickAction = () => console.log('Click'),
	onRemoveAction = () => console.log('Delete'),
	noIcon,
	reclamationType = false,
	isNextStep = false,
	isExchangeVariant = false,
	currency,
	...other
}) => {
	let dispatch = useDispatch()
	let [isImageError, setImageError] = useState(false)
	return (
		<CurrentItemPreview
			{...other}
			reclamationType={reclamationType}
			isHandled={isHandled}
			isActive={isActive}
			onClick={(e) => {
				//if (reclamationType) {
				let currentTarget = e.target
				let currentParent = currentTarget.parentNode

				if (
					currentTarget.dataset.type === controlType ||
					currentParent.dataset.type === controlType
				) {
					if (isExchangeVariant) {
						dispatch(setIsNeedToRemoveExchangeVariant(orderItemId))
					} else {
						onRemoveAction(setFlow, orderItemId)
						overflowBodyRemove()
					}
				} else {
					onClickAction()
				}
				//}
			}}
		>
			{!noIcon && (
				<DeleteIcon
					data-type={controlType}
					reclamationType={reclamationType}
				>
					{!isNextStep && (
						<Icon data-type={controlType} component='trash' />
					)}
				</DeleteIcon>
			)}
			<Preview reclamationType={reclamationType}>
				{imageUrl.length ? (
					isImageError ? (
						<NoPreview>
							<Icon component='noPreview' />
						</NoPreview>
					) : (
						<img
							src={imageUrl[0]}
							alt={name}
							onError={() => {
								setImageError(true)
							}}
						/>
					)
				) : (
					<NoPreview>
						<Icon component='noPreview' />
					</NoPreview>
				)}
			</Preview>
			<Body reclamationType={reclamationType}>
				<Name reclamationType={reclamationType}>{name}</Name>
				<ItemAttributes
					reclamationType
					isShowOnMobile={false}
					size='small'
					attributes={attributes}
				/>
			</Body>
			<Price reclamationType={reclamationType}>
				{formatPrice(price, currency)}
			</Price>
		</CurrentItemPreview>
	)
}

export default ItemPreview
